import React, { useState, useEffect, useContext } from 'react';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import AddBoxIcon from '@material-ui/icons/AddBox';
import EditIcon from '@material-ui/icons/Edit';
import { GlobalContext } from '../../Contexts/GlobalContext';
import useFetch from '../../CustomHooks/useFetch';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import IconButton from '@material-ui/core/IconButton';
import useGuiTranslations from '../MultiLanguage/useGuiTranslations';
import {capitalizeFirstLetter} from '../../Util/StringFunctions';


export default function ProductsTable(props) {
    const { selectedCategoryId, addProduct, editProduct } = props;
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const [getProductsResponse, getProductsHook] = useFetch();
    const [setProductOrderHookResponse, setProductOrderHook] = useFetch();
    const [deleteProductHookResponse, deleteProductHook] = useFetch();
    const [translateGui] = useGuiTranslations();

    function getProducts() {
        globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '...', showButton: false } });
        getProductsHook(
            {
                url: '/admin/products?PageNumber=1&PageSize=100&CategoryId=' + selectedCategoryId,
                method: 'GET',
                postData: null,
                addTokenHeader: true,
            }
        )
    }

    useEffect(
        () => {
            getProducts();
        }, [selectedCategoryId]
    )

    useEffect(
        () => {
            globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '', showButton: false } });
        }, [getProductsResponse]
    )

    const changeProductOrder = (productId, direction) => {
        setProductOrderHook(
            {
                url: `/admin/products/${productId}/move/${direction}`,
                method: 'PUT',
                addTokenHeader: true,
            }
        )
    }

    useEffect(
        () => {
            console.log(setProductOrderHookResponse);
            if (setProductOrderHookResponse.success != null) {
                getProducts();
            }
        }, [setProductOrderHookResponse]
    )

    const deleteProduct = (productId) => {
        deleteProductHook(
            {
                url: `/admin/products/${productId}?softDelete=true`,
                method: 'DELETE',
                addTokenHeader: true,
            }
        )
    }

    useEffect(
        () => {
            if (deleteProductHookResponse.length != 0 && deleteProductHookResponse) {
                //console.log('okmis');
                getProducts();
            }
        }, [deleteProductHookResponse]
    )


    return (
        <Paper elevation={3} style={{ padding: '10px', marginBottom: '30px' }}>
            <div className={classes.flex}>
                <span className={classes.title}>{capitalizeFirstLetter(translateGui(6))} </span>

                <IconButton color="primary" id="add-product-icon" aria-label="upload picture" component="span" onClick={addProduct}>
                    <AddBoxIcon />
                </IconButton>
            </div>
            <table className={classes.table}>
                <thead>
                    <tr>
                        <th>
                            {capitalizeFirstLetter(translateGui(35))}
            </th>
                        <th>
                        {capitalizeFirstLetter(translateGui(6))}
            </th>
                        <th>
                        {capitalizeFirstLetter(translateGui(27))}
            </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        getProductsResponse.products != null ?
                            getProductsResponse.products.map(
                                (product, index) =>
                                    <tr key={index} >
                                        <td >
                                            <IconButton className={classes.iconButton}>
                                                <ArrowDownwardIcon className={classes.cursor} onClick={() => changeProductOrder(product.id, 'Down')}></ArrowDownwardIcon>
                                            </IconButton>
                                            <IconButton className={classes.iconButton}>
                                                <ArrowUpwardIcon className={classes.cursor} onClick={() => changeProductOrder(product.id, 'Up')}></ArrowUpwardIcon>
                                            </IconButton>
                                            <IconButton aria-label={'edit ' + product.title} className={classes.iconButton}>
                                                <EditIcon className={classes.cursor} style={{ marginLeft: '10px' }} onClick={() => editProduct(product.id)}></EditIcon>
                                            </IconButton>
                                            <IconButton  className={classes.iconButton}>
                                                <DeleteOutlineIcon className={classes.cursor} style={{ marginLeft: '10px' }} onClick={() => deleteProduct(product.id)}></DeleteOutlineIcon>
                                            </IconButton>
                                        </td>
                                        <td>
                                            {product.title}
                                        </td>
                                        <td>
                                            {product.price}
                                        </td>
                                    </tr>
                            )
                            : null
                    }
                </tbody>
            </table>
        </Paper>

    )
}

const useStyles = makeStyles({
    table: {
        width: '100%',
        '& td': {
            padding: '10px 0',
            borderBottom: '1px solid rgba(224, 224, 224, 1)',
        },
        '& td:nth-child(1)': {
            textAlign: 'center',
        },
        '& th:nth-child(n+2)': {
            textAlign: 'left',
        },
        '& th': {
            padding: '20px 0',
            borderBottom: '1px solid rgba(224, 224, 224, 1)',
        }
    },
    cursor: {
        cursor: 'pointer',
    },
    flex: { "display": "flex", "alignItems": "center", "justifyContent": "space-between", margin: '30px 10px 50px 10px' },
    title: { fontSize: '1.4rem', fontWeight: 500, },
    addIcon: { color: '#5dbcd2' },
    iconButton: {padding: '12px 5px'},

});